import Repository from "./RepositoryFactoryMain";

const CREATE_TRANSACTION = "create";
const UPDATE_TRANSACTION = "edit";
const GET_TRANSACTION = "get";

export default {
  CreateTransaction(payload) {
    return Repository.post(transformRoute(CREATE_TRANSACTION), payload);
  },
  UpdateTransaction(payload) {
    return Repository.post(transformRoute(UPDATE_TRANSACTION), payload);
  },
  GetTransaction(payload) {
    return Repository.post(transformRoute(GET_TRANSACTION), payload);
  },
};

const transformRoute = (route) => {
  return `/transaction/${route}`;
};
